import { ITypedReduxAction } from '../../../types/redux/actionType';
import { EUserLkType } from '../../../types/user';

export enum ESetLkTypeActionType {
  Set = 'user/setLkType/set',
}

export type TLkType = ITypedReduxAction<ESetLkTypeActionType.Set, EUserLkType>;
